'use strict';

require('../../style/index.css');

require('./index.css');

require('../../button/style/css');


//////////////////
// WEBPACK FOOTER
// ./~/_antd@2.13.2@antd/lib/modal/style/css.js
// module id = 1299
// module chunks = 0